export default "__VITE_PUBLIC_ASSET__4c1b0ac0__"